import { render } from "./IconItemCategoryHobby.vue?vue&type=template&id=4faddcfb"
import script from "./IconItemCategoryHobby.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryHobby.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__